exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-img[data-v-122180d8]{max-width:12rem}", ""]);

// exports
